import { initializeApp } from "firebase/app";
import {
  getAuth, GoogleAuthProvider, signInWithPopup, signOut,
  createUserWithEmailAndPassword, sendEmailVerification,
  signInWithEmailAndPassword, sendPasswordResetEmail
}
from "firebase/auth";
import { showError } from "../utils/toast";

const firebaseConfig = {
  apiKey: "AIzaSyAt_KA1m7cxn7dtmM1YNOpwRNZVvKuzZ0A",
  authDomain: "red-vc.firebaseapp.com",
  projectId: "red-vc",
  storageBucket: "red-vc.firebasestorage.app",
  messagingSenderId: "905275325502",
  appId: "1:905275325502:web:9983e9f4d22563c74d256f",
  measurementId: "G-GF0572JS63"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export const signInWithGoogle = () => {
  return signInWithPopup(auth, googleProvider);
};

export const LogoutUser = () => {
  return signOut(auth)
    .then(() => {
      console.log("User logged out");
      localStorage.clear();
    })
    .catch((error) => {
      console.error("Logout error:", error);
    });
};

export const HandleSignupWithEmail = async (email, password) => {
  try {
    const userCred = await createUserWithEmailAndPassword(auth, email, password);
    await sendEmailVerification(userCred.user);
    showError("Verification email sent!");
  } catch (err) {
    console.log(err.message);
    handleFirebaseError(err);
  }
};

export const HandleLoginWithEmail = async (email, password) => {
  try {
    const userCred = await signInWithEmailAndPassword(auth, email, password);

    if (!userCred.user.emailVerified) {
      showError("Please verify your email first.");
      return;
    }

    console.log("Logged in");
    return userCred;
  } catch (err) {
    console.log(err.message);
    handleFirebaseError(err);
  }
};

export const HandleForgotPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    showError("Reset link sent to your email");
  } catch (err) {
    console.log(err.message);
    handleFirebaseError(err);
  }
};

const handleFirebaseError = (error) => {
  let message = "";

  switch (error.code) {
    case "auth/email-already-in-use":
      message = "This email is already registered. Try logging in.";
      break;

    case "auth/invalid-email":
      message = "Please enter a valid email address.";
      break;

    case "auth/invalid-credential":
      message = "Please enter a valid credential.";
      break;

    case "auth/weak-password":
      message = "Password must be at least 6 characters.";
      break;

    case "auth/missing-password":
      message = "Please enter a password.";
      break;

    default:
      message = "Something went wrong. Please try again.";
  }

  showError(message);
};